import { useEffect } from 'react';
import React, { useContext } from 'react';
import { AuthContext } from '../../context/Auth/AuthContext';

export const Logout = () => {
  const auth = useContext(AuthContext);

  useEffect(() => {
    auth.signout();
  });

  return <div>Saindo ...</div>;
};

export default Logout;
